<template>
  <admin-wrapper :inputs="inputs" disable-sticky-buttons />
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'ScadaThreeTabData',
  components: { AdminWrapper },
  computed: {
    inputs() {
      return [
        {
          name: 'scada_3_module_measurements_refresh_interval',
          translationPath: 'admin.refreshInterval',
          subtitle: 'admin.setScadaRefreshInterval',
          dataType: {
            name: 'integer',
          },
          rules: [v => v === 0 || Boolean(v) || 'rules.required'],
          align: 'start',
          allowNegative: false,
          minValue: 1,
        },
      ];
    },
  },
};
</script>
